export default [
  {
    path: "/workbench",
    name: "Workbench",
    component: () => import("@/views/workbench/workbench"),
    meta: {title: "控制台", activeMenu: "/workbench"},
  }

]
